import { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

/**
 * Runs a given function on navigating away to one of the given targets without calling it on the first render
 * @param onNavigateAway the function to call on navigation to one of the paths
 * @param cleanUpPaths the paths that trigger the function
 */
const useTriggerOnNavigation = (onNavigateAway: () => void, cleanUpPaths: string[]) => {
    const history = useHistory();

    // Read through refs: both args get a fresh identity every render, which would otherwise
    // re-subscribe the listener on each one.
    const onNavigateAwayRef = useRef(onNavigateAway);
    const cleanUpPathsRef = useRef(cleanUpPaths);
    onNavigateAwayRef.current = onNavigateAway;
    cleanUpPathsRef.current = cleanUpPaths;

    useEffect(() => {
        const unlisten = history.listen((newLocation) => {
            if (cleanUpPathsRef.current.includes(newLocation.pathname)) {
                onNavigateAwayRef.current();
            }
        });

        return () => unlisten();
    }, [history]);
};

export default useTriggerOnNavigation;
